import { Component, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MAT_DIALOG_DATA , MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'mod-indices-dialogue',
  templateUrl: './market-indices.dialogue.html',
  styleUrls: ['./market-indices.component.css']
})
export class MarketIndicesDialogueComponent  {

  public cdnUrl: String;
  public cdnVersion: String;
  public chartUrl: String;
  public timeStamp: String;
  public dataBlock: any [] = new Array();

  constructor(
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<MarketIndicesDialogueComponent>
    ) {
      this.cdnUrl = data.cdnUrl;
      this.cdnVersion = data.cdnVersion;
      this.chartUrl = data.chartUrl;
      this.timeStamp = data.timeStamp;
      this.dataBlock = data.dataBlock;
      }

      closelDialog () {
        this.dialogRef.close();
      }
}
